import { Helmet } from "react-helmet-async";
import DOMPurify from "dompurify";

export interface PlayerSEOProps {
  title: string;
  description: string;
  thumbnail: string;
  source: string;
}

export default function PlayerSeo({title, description, thumbnail, source}: PlayerSEOProps) {
  return (
    <Helmet>
      <title>{DOMPurify.sanitize(title)}</title>
      <meta name="description" content={DOMPurify.sanitize(description)}/>
      <meta name="image" content={thumbnail}/>
      <meta name="title" content={DOMPurify.sanitize(title)}/>

      { /* Facebook tags */}
      <meta property="og:title" content={DOMPurify.sanitize(title)}/>
      <meta property="og:description" content={DOMPurify.sanitize(description)}/>
      <meta property="og:image" content={DOMPurify.sanitize(thumbnail)}/>
      <meta property="og:type" content="video"/>

      { /* Twitter tags */}
      <meta name="twitter:card" content="player"/>
      <meta name="twitter:title" content={DOMPurify.sanitize(title)}/>
      <meta name="twitter:description" content={DOMPurify.sanitize(description)}/>
      <meta name="twitter:image" content={DOMPurify.sanitize(thumbnail)}/>
      <meta name="twitter:player" content={source}/>

    </Helmet>
  )
}
